import defaultAvatarPath from 'assets/images/default-avatar.svg';

import {
  JobMatchDeclinationReasonsEnum,
  JobMatchDeclinationReasonsUsEnum,
  SkillTypeEnum,
  TalentLanguageEnum,
  TalentMarketingSourceEnum,
} from '@libs/graphql-types';
import { OptionType } from '@libs/ui/components/form/select';

export const DEFAULT_AVATAR = defaultAvatarPath;

export const SKILL_TYPES_MAP = {
  [SkillTypeEnum.HardSkills]: 'Hard Skills',
  [SkillTypeEnum.Solutions]: 'Solutions',
  [SkillTypeEnum.SoftSkills]: 'Soft Skills',
};
export const INFINITY_SIGN = '∞';

export const OPENTALENT_COMPANY_ID = '1';

export const REJECTION_REASONS: OptionType[] = Object.entries({
  'Does Not Meet Requirements - Skills':
    JobMatchDeclinationReasonsEnum.NotEnoughSkills,
  'Does Not Meet Requirements - Qualifications':
    JobMatchDeclinationReasonsEnum.DoesntMeetQualifications,
  'Does Not Meet Requirements - Salary':
    JobMatchDeclinationReasonsEnum.DoesntMeetSalary,
  'Does Not Meet Requirements - Visa':
    JobMatchDeclinationReasonsEnum.DoesntMeetVisa,
  'Position Closed': JobMatchDeclinationReasonsEnum.PositionClosed,
  'Position Filled': JobMatchDeclinationReasonsEnum.PositionFilled,
  'Other candidates are better match':
    JobMatchDeclinationReasonsEnum.OtherCandidatesAreBetterMatch,
  'Duplication of Candidate':
    JobMatchDeclinationReasonsEnum.DuplicationOfCandidate,
  'Candidate Withdrew Application':
    JobMatchDeclinationReasonsEnum.CandidateWithdrewApplication,
  'Cultural Fit Concerns or other':
    JobMatchDeclinationReasonsEnum.CulturalFitConcernsOrOther,
}).map(([text, value]) => ({ value, text }));

const REJECTION_REASONS_US_MAP: Record<string, string> = {
  // [JobMatchDeclinationReasonsUsEnum.None]: 'No Reason Specified',
  [JobMatchDeclinationReasonsUsEnum.AcceptedOtherPosition]:
    'Accepted Other Position',
  [JobMatchDeclinationReasonsUsEnum.BillRateExceedsMaxRate]:
    'Bill Rate Exceeds Maximum Rate',
  [JobMatchDeclinationReasonsUsEnum.CancelledJobPosting]:
    'Job Posting Cancelled',
  [JobMatchDeclinationReasonsUsEnum.CandidateWithdrew]: 'Candidate Withdrew',
  [JobMatchDeclinationReasonsUsEnum.DoesNotMeetRequirements]:
    'Does Not Meet Requirements',
  [JobMatchDeclinationReasonsUsEnum.DuplicateSubmittal]: 'Duplicate Submittal',
  [JobMatchDeclinationReasonsUsEnum.IncorrectSubmittal]: 'Incorrect Submittal',
  [JobMatchDeclinationReasonsUsEnum.InterviewNoShowOrNonResponsive]:
    'Interview No-Show or Non-Responsive',
  [JobMatchDeclinationReasonsUsEnum.IssueWithPostingRecreated]:
    'Issue with Posting - Recreated',
  [JobMatchDeclinationReasonsUsEnum.RejectedContactProgramOffice]:
    'Rejected - Contact Program Office',
  [JobMatchDeclinationReasonsUsEnum.RejectionNewRole]: 'Rejection - New Role',
  [JobMatchDeclinationReasonsUsEnum.RejectionUnsuitable]:
    'Rejection - Unsuitable',
  [JobMatchDeclinationReasonsUsEnum.UnsuccessfulAtInterview]:
    'Unsuccessful at Interview',
};

export const REJECTION_REASONS_US: OptionType[] = Object.entries(
  REJECTION_REASONS_US_MAP,
).map(([value, text]) => ({ value, text }));

export const LANGUAGES_MAP = {
  [TalentLanguageEnum.Arabic]: 'Arabic',
  [TalentLanguageEnum.Bengali]: 'Bengali',
  [TalentLanguageEnum.Chinese]: 'Chinese',
  [TalentLanguageEnum.English]: 'English',
  [TalentLanguageEnum.French]: 'French',
  [TalentLanguageEnum.FrenchCreole]: 'French Creole',
  [TalentLanguageEnum.German]: 'German',
  [TalentLanguageEnum.Hindi]: 'Hindi',
  [TalentLanguageEnum.Japanese]: 'Japanese',
  [TalentLanguageEnum.Mandarin]: 'Mandarin',
  [TalentLanguageEnum.Russian]: 'Russian',
  [TalentLanguageEnum.Spanish]: 'Spanish',
};

export const LANGUAGES: OptionType[] = Object.entries(LANGUAGES_MAP).map(
  ([value, text]) => ({ value, text }),
);

export const HOW_TO_KNOW_OPTIONS: OptionType[] = [
  { value: TalentMarketingSourceEnum.ClientWebsite, text: 'Client Website' },
  {
    value: TalentMarketingSourceEnum.EmployeeReferral,
    text: 'Employee Referral',
  },
  { value: TalentMarketingSourceEnum.SearchEngine, text: 'Search Engine' },
  { value: TalentMarketingSourceEnum.Other, text: 'Other' },
];
